import axios from '@/api/config'

const additionGoods = {
  getAdditionGoodsList (data) {
    return axios.get(`${process.env.BASE_URL}/additionGoods/getAdditionGoodsList` , {params: data})
  },
  addAdditionGoods (data) {
    return axios.post(`${process.env.BASE_URL}/additionGoods/addAdditionGoods` , data)
  },
  deleteAdditionGoods (data) {
    return axios.delete(`${process.env.BASE_URL}/additionGoods/deleteAdditionGoods` , {data: data})
  },

}

export default additionGoods



// WEBPACK FOOTER //
// ./src/api/additionGoods.js